// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container Style */
.login-container {
    padding: 20px;
    max-width: 400px;
    margin: 0 auto;
    text-align: center;
  }
  
  /* Form Style */
  .login-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  /* Input Field Style */
  .login-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
  }
  
  /* Button Style */
  .login-button {
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .login-button:hover {
    background-color: #0056b3;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["/* Container Style */\n.login-container {\n    padding: 20px;\n    max-width: 400px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  /* Form Style */\n  .login-form {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  /* Input Field Style */\n  .login-input {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 1rem;\n  }\n  \n  /* Button Style */\n  .login-button {\n    padding: 10px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .login-button:hover {\n    background-color: #0056b3;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
